// config.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

import { loadComponentConfig } from './component-config.actions';
import { selectComponentConfigLoaded } from './component-config.selectors';

@Injectable({
  providedIn: 'root'
})
export class ComponentConfigGuard implements CanActivate {
  constructor(private store: Store) {}

  canActivate(): Observable<boolean> {
    //this.store.dispatch(loadComponentConfig());

    return this.store.select(selectComponentConfigLoaded).pipe(
      filter(loaded => loaded),
      map(config => {
        console.log('Compoent Config loaded', config);
        return true;
      }),
      take(1)
    );
  }
}
